module.exports = __webpack_public_path__ + "static/img/bg.f236203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anxiang/bg.png
// module id = wyRq
// module chunks = 1